<svg class="svg_icon--magnify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--magnify .icon{fill:currentColor;}</style>
  </defs>
  <title>Take a peak</title>
  <path class="icon"
        d="M85.25,76.44,70.55,60.85A33.38,33.38,0,1,0,59.72,71.22L74.34,86.73A7.5,7.5,0,0,0,85.25,76.44Zm-66-33.85A23.42,23.42,0,1,1,42.69,66,23.44,23.44,0,0,1,19.27,42.59Z"/>
</svg>
